<template>
  <b-row class="base-row-padded">
    <b-col>
      <h2>Groups</h2>
      <GroupsPagination :perPage="20" :queryStructure="queryStructure" @items-updated="itemsUpdated"
        ref="paginationComponent" />
      <b-row>
        <b-col xs="2" class="mx-1 mb-2" align="end" v-if="!pickerMode">
          <b-button variant="success" @click="createGroup">New Device Group</b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-table :fields="fields" :items="groupsArray" :busy="groupsArray === null" selectable @row-clicked="showGroup"
          :select-mode="'single'" :striped="true" :small="true" :hover="true" :responsive="true" :stacked="'sm'"
          :tbody-tr-class="rowClassFilter">
          <template slot="name" slot-scope="data">
            {{ data.item.name }}
          </template>

          <template slot="devices_count" slot-scope="data">
            {{ data.item.devices_count }}
          </template>


          <template #cell(id)="data" v-if="!pickerMode">
            <b-button class="m-1" variant="primary" size="sm" @click.prevent="showGroup(data.item.id)">Edit</b-button>
            <b-button class="m-1" variant="danger" size="sm"
              @click.prevent="deleteGroupProxy(data.item)">Delete</b-button>
          </template>
        </b-table>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import formsMixin from '@/mixins/forms';
import groupsMixin from '@/views/admin/groups/groupsMixin';
import GroupsPagination from './pagination/GroupsPagination.vue';

export default {
  components: { GroupsPagination },
  mixins: [formsMixin, groupsMixin],
  props: {
    pickerMode: {
      type: [Boolean],
      required: false,
      default: false,
    },
    pickedItemId: {
      type: [Number],
      required: false,
      default: -1,
    },
  },
  data() {
    return {
      groupsArray: null,
      queryStructure: {
        pagePropName: 'page',
        perPagePropName: 'per_page',
        searchPropName: 'search',
        unassignedDevicesFilterPropName: 'unassigned_devices_only',
        responseDataKey: 'groups',
      },
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'devices_count', label: 'Number of Devices' },
        { key: 'id', label: 'Options', tdClass: 'td-no-wrap' },
      ],
      publishStatus: ['Unpublished', 'Published'],
    };
  },
  methods: {
    itemsUpdated(data) {
      this.groupsArray = data;
    },
    deleteGroupProxy(group) {
      this.deleteGroup(group).then(() => {
        this.$refs.paginationComponent.pageChanged();
      }).catch(() => { });
    },
    statusChanged() {
      this.$refs.paginationComponent.pageChanged(1);
    },
    showGroup(target) {
      if (this.pickerMode) {
        this.$emit('item-clicked', target);
        return;
      }

      let finalTarget = null;

      if (typeof target === 'number') {
        finalTarget = target;
      } else if (target && target.id) {
        finalTarget = target.id;
      }
      this.$router.push({ name: 'showGroup', params: { id: finalTarget } });
    },
    createGroup() {
      this.$router.push({ name: 'showGroup', params: { id: 'new' } });
    },
    rowClassFilter(item) {
      if (this.pickerMode) {
        if (this.pickedItemId === item.id) {
          return 'bg-secondary';
        }
      }
      return '';
    },
  },
};
</script>
